<template lang="pug">
  div(v-cloak).sub-page
    CommonHeader
    main
      v-container
        h1 ビュルガー商品を使った
          br
          | おすすめレシピ
        v-layout.justify-center(row wrap)
          img(src='/static/images/recipe_pic_mrsburger.png' width=250 height=137 alt='簡単お手軽なレシピがいっぱい!')
        v-layout.item_wrap.mb-5(row wrap v-for='(item,index) in items' :key='item.key' :id="item.key")
          v-flex.title_wrap(xs12)
            img(:src="'/static/images/illust_' + item.key + '.png'" :alt="item.name + 'イラスト'")
            h2.de.white--text(style='font-size: 2.3rem')
              | {{ item.de }}
              span.secondary--text.py-1.mincho(style='display: block;font-size:1.1rem')
                | {{ item.name }}
                br
                | を使ってこんなメニュー！
          v-layout.mt-2(row wrap)
            v-flex.pa-2.gothic.image_btn(xs6 sm4 href='#modal_top' v-for='(n,index) in item.modal' :key='n.id' flat)
              v-img(@click='modalOpen(n)' :src="'/static/images/recipe/' + n.id + '.jpg'")
              div.image_btn_text.primary.white--text {{ n.title }}
    CommonFooter
    modal(:val='postItem' v-show='showContent' @close='modalClose')
</template>

<script>
import CommonHeader from '@/app/pages/Landing/Header.vue'
import CommonFooter from '@/app/pages/Landing/Footer.vue'
import Modal from '@/app/pages/Landing/Modal.vue'
export default {
  components: {
    CommonHeader,
    CommonFooter,
    Modal
  },
  mounted: function () {
  },
  data () {
    return {
      showContent: false,
      postItem: null,
      items: [
        {
          key: 'mini',
          de: 'Mini Maultaschen',
          name: 'ミニマウルタッシェン',
          catchphrase: 'ミートとチーズの二種類。',
          modal: [
            {
              id: 'mini1',
              title: 'ミニマウルタッシェンの\nフライドスナック',
              text: 'そのまま揚げるだけ！おやつにもおかずの一品としても。',
              comment: 'そのままでも、ケチャップと一緒でも美味しく召し上がれます。',
              ingredients: [
                {
                  ingredient: 'ミニマウルタッシェン',
                  quantity: 'お好みの量'
                }, {
                  ingredient: 'お好みのソース',
                  quantity: '適量'
                }
              ],
              directions: [
                { direction: '凍ったままのミニマウルタッシェンを180℃の油で3〜4分揚げます。' }
              ]
            },
            {
              id: 'mini2',
              title: 'ミニマウルタッシェン\nお好きなソースで',
              text: 'そのままボイルしてソースをつけるだけ！',
              comment: 'トマトソースやホワイトソースなど、色々なソースに合います。',
              ingredients: [
                {
                  ingredient: 'ミニマウルタッシェン',
                  quantity: 'お好みの量'
                }, {
                  ingredient: 'お好みのソース',
                  quantity: '適量'
                }
              ],
              directions: [
                { direction: '沸騰したお湯で、冷凍のままのミニマウルタッシェンを4〜5分ゆでます。' },
                { direction: 'お湯を切り、お好みのソースに絡めればできあがり。' }
              ]
            },
            {
              id: 'mini3',
              title: 'ミニマウルタッシェンの\nサラダ',
              text: 'いつものサラダがボリュームアップ。お好みのドレッシングで召し上がれ!',
              comment: 'オリーブオイル、白ワインビネガー、粉チーズをかけて食べるのもおすすめです。',
              ingredients: [
                {
                  ingredient: 'ミニマウルタッシェン',
                  quantity: 'お好みの量'
                }, {
                  ingredient: 'お好みの野菜',
                  quantity: '適量'
                }, {
                  ingredient: 'お好みのドレッシング',
                  quantity: '適量'
                }
              ],
              directions: [
                { direction: '沸騰したお湯で冷凍のままのミニマウルタッシェンを入れて、4～5分茹でます。' },
                { direction: '熱したフライパンで両面に焼き色をつけます。' },
                { direction: 'サラダにトッピングし、お好みのドレッシングをかけてできあがり。' }
              ]
            },
            {
              id: 'mini4',
              title: 'ミニマウルタッシェンの\nコンソメスープ',
              text: 'さっと出来ちゃう簡単スープ!',
              comment: 'ミニマウルタッシェンに味がついてるので、シンプルなスープがよく合います。',
              ingredients: [
                {
                  ingredient: 'ミニマウルタッシェン',
                  quantity: 'お好みの量'
                }, {
                  ingredient: 'コンソメ',
                  quantity: '適量'
                }, {
                  ingredient: 'パセリ',
                  quantity: '適量'
                }
              ],
              directions: [
                { direction: '沸騰したお湯で、冷凍のままのミニマウルタッシェンを4〜5分茹でます。' },
                { direction: 'コンソメスープの中に入れ、パセリを振りかければできあがり。' }
              ]
            },
            {
              id: 'mini5',
              title: 'ミニマウルタッシェンの\nグラタン',
              text: 'ミニマウルタッシェンチーズを使って簡単グラタン。\nもちろんミートで作ってもOK！',
              comment: '振りかけるチーズはパルメジャーノ、グリュエール、グラナパダーノなど硬めのがおすすめです。',
              ingredients: [
                {
                  ingredient: 'ミニマウルタッシェンチーズ',
                  quantity: '10個'
                }, {
                  ingredient: '生クリーム',
                  quantity: '適量'
                }, {
                  ingredient: 'チーズ',
                  quantity: '適量'
                }, {
                  ingredient: 'ナツメグ',
                  quantity: '適量'
                }, {
                  ingredient: 'チーズ',
                  quantity: '適量'
                }, {
                  ingredient: '塩・こしょう',
                  quantity: '適量'
                }
              ],
              directions: [
                { direction: 'ミニマウルタッシェンはたっぷりの沸騰した湯で4～5分茹でます。' },
                { direction: 'フライパンにバターを溶かして、焦げ目がつくまでミニマウルタッシェンをソテーする。' },
                { direction: '耐熱皿に2.を並べ入れ、ミニマウルタッシェンがひたる位の生クリームを注ぎ入れる。' },
                { direction: '3.に塩・こしょう、ナツメグ、上からすりおろしたチーズをたっぷり振りかける。' },
                { direction: '250℃に予熱しておいたオーブンで、チーズがこんがり溶けるまで焼いてできあがり！（～15分くらいが目安です）' }
              ]
            },
            {
              id: 'mini6',
              title: 'ミニマウルタッシェンと\nクヌーデルのスープ',
              text: 'ドイツのじゃがいものお団子クネーデル（Knödel）と一緒に',
              comment: 'クネーデルとはジャガイモがはいったお団子です。ジャガイモだけじゃなく、肉や魚の身をすりつぶして団子状にして、茹でたり煮込んだりするそうです。',
              ingredients: [
                {
                  ingredient: 'ミニマウルタッシェン',
                  quantity: 'お好みの量'
                }, {
                  ingredient: 'コンソメ',
                  quantity: '適量'
                }, {
                  ingredient: '【クネーデル】',
                  quantity: '　'
                }, {
                  ingredient: 'じゃがいも',
                  quantity: '中6コ'
                }, {
                  ingredient: '塩',
                  quantity: '小さじ１'
                }
              ],
              directions: [
                { direction: 'ジャガイモは茹でて熱いうち皮をむき、マッシャーなどでよくつぶします。' },
                { direction: '1.に薄力粉を振るいながら加える。塩を入れて全体が均一になるまでよく混ぜて、だんご状に丸めます。' },
                { direction: '鍋にたっぷり湯を沸かし、塩(分量外)を入れて中火で浮き上がってくるまで茹でて取り出します。' },
                { direction: '沸騰したお湯にコンソメスープの素を溶かします。' },
                { direction: '冷凍のままのミニマウルタッシェンを4〜5分茹でます。お好みの材料を入れてもOKです。' },
                { direction: '3.のクヌーデルを入れてできあがり。' }
              ]
            },
            {
              id: 'mini7',
              title: 'ミニマウルタッシェンの\nやさしい豆乳スープ',
              text: '豆乳を使ってヘルシーに',
              comment: '油揚げが名脇役、いいダシでてます！',
              ingredients: [
                {
                  ingredient: 'ミニマウルタッシェン',
                  quantity: 'お好みの量'
                }, {
                  ingredient: 'チキンブイヨン',
                  quantity: '15g'
                }, {
                  ingredient: 'お好みのキノコ',
                  quantity: 'お好きな量'
                }, {
                  ingredient: '刻んだ油揚げ',
                  quantity: '1/2枚'
                }, {
                  ingredient: '豆乳',
                  quantity: '600cc'
                }, {
                  ingredient: '浅葱',
                  quantity: '適量'
                }, {
                  ingredient: '塩',
                  quantity: '適量'
                }
              ],
              directions: [
                { direction: 'チキンブイヨンをあたためたところに、マウルタッシェン、お好みのキノコ、刻んだ油揚げを入れてことこと煮ます。' },
                { direction: '12～13分くらい煮たところで、豆乳を加えます。' },
                { direction: '鍋にたっぷり湯を沸かし、塩を入れて中火で浮き上がってくるまで茹でます。' },
                { direction: '一煮立ちしたらお皿に盛って浅葱をトッピングしてできあがり。' }
              ]
            },
            {
              id: 'mini8',
              title: 'ミニマウルタッシェンの\nトマトクリーム煮込み',
              text: 'トマトの酸味と生クリームのコクが美味しい。',
              comment: 'あれば角切りにしたフレッシュトマトを入れて煮込んでも美味しいです。',
              ingredients: [
                {
                  ingredient: 'ミニマウルタッシェン',
                  quantity: 'お好みの量'
                }, {
                  ingredient: 'チキンブイヨン',
                  quantity: '15g'
                }, {
                  ingredient: 'ホールトマト缶',
                  quantity: '1缶'
                }, {
                  ingredient: 'ブロッコリー',
                  quantity: '適量'
                }, {
                  ingredient: '生クリーム',
                  quantity: '50ml'
                }
              ],
              directions: [
                { direction: '凍ったままのミニマウルタッシェンを4〜5分茹でます。' },
                { direction: 'チキンブイヨンを温め市販のトマトソースを入れて加熱し、1.を入れます。' },
                { direction: '煮立ったら弱火にしてブロッコリーを入れ10分くらいことこと煮込みます。' },
                { direction: '生クリームを入れて一煮立ちさせたら火を止めてできあがり。' }
              ]
            },
            {
              id: 'mini9',
              title: 'ミニマウルタッシェンの\nトマトツナ和え',
              text: 'トマトの酸味とツナが美味しい',
              comment: 'ミニマウルタッシェンはどちらでもいいですが、チーズがおすすめです。',
              ingredients: [
                {
                  ingredient: 'ミニマウルタッシェン',
                  quantity: 'お好みの量'
                }, {
                  ingredient: 'ツナ缶',
                  quantity: '１缶'
                }, {
                  ingredient: 'ホールトマト',
                  quantity: '１缶'
                }, {
                  ingredient: '玉ねぎ',
                  quantity: '1/2個'
                }, {
                  ingredient: 'タイム',
                  quantity: '適量'
                }, {
                  ingredient: 'ローリエ',
                  quantity: '適量'
                }, {
                  ingredient: '塩・こしょう',
                  quantity: '適量'
                }
              ],
              directions: [
                { direction: '沸騰したお湯で、冷凍のままのミニマウルタッシェンを4〜5分茹でます。' },
                { direction: '玉ねぎをみじん切りしたものをオリーブオイルでじっくり炒めた後、ホールトマト缶とツナ缶を入れて、タイム、ローリエといっしょにくつくつ煮込みます。' },
                { direction: 'トロミがでてきたら塩胡椒で味をととのえてできあがり。' }
              ]
            },
            {
              id: 'mini10',
              title: 'ミニマウルタッシェンの\n餃子風',
              text: 'ドイツの餃子とも言われるマウルタッシェン。そのまま餃子風にしちゃいました。',
              comment: '餃子のタレはみりんやにんにくを入れてもgood。お好みのタレでお楽しみください。',
              ingredients: [
                {
                  ingredient: 'ミニマウルタッシェン',
                  quantity: 'お好みの量'
                }, {
                  ingredient: 'ごま油',
                  quantity: '適量'
                }, {
                  ingredient: 'しょうゆ',
                  quantity: '大さじ２'
                }, {
                  ingredient: '酢',
                  quantity: '大さじ２'
                }, {
                  ingredient: 'ラー油',
                  quantity: '適量'
                }
              ],
              directions: [
                { direction: 'しょう油、酢、ラー油を混ぜてタレを作る。' },
                { direction: 'マウルタッシェンを冷凍のまま3～4分ボイルします。' },
                { direction: 'フライパンにごま油を熱して、両面こんがり焼き目をつけてできあがり。' },
                { direction: 'タレに付けてご賞味ください。' }
              ]
            },
            {
              id: 'mini11',
              title: 'ミニマウルタッシェンの\nプロフィットロール\n（チーズ）',
              text: 'マウルタッシェンチーズはデザートにしても美味しい！',
              comment: 'アイスクリームや季節のフルーツを添えると見た目も華やかに。',
              ingredients: [
                {
                  ingredient: 'ミニマウルタッシェンチーズ',
                  quantity: 'お好みの量'
                }, {
                  ingredient: '生クリーム',
                  quantity: '適量'
                }, {
                  ingredient: 'チョコレートソース',
                  quantity: '適量'
                }, {
                  ingredient: 'パウダーシュガー',
                  quantity: '適量'
                }
              ],
              directions: [
                { direction: 'ミニマウルタッシェンチーズをカラリと揚げ、油をきって粗熱をとります。' },
                { direction: 'ホイップした生クリーム、チョコレートソース、パウダーシュガーを振りかけてできあがり' }
              ]
            }
          ]
        }, {
          key: 'schupfnudeln',
          de: 'Schupfnudeln',
          name: 'フィンガーポテト',
          catchphrase: 'ドイツ風じゃがいもパスタ。もちもち食感！',
          modal: [
            {
              id: 'schupfnudeln1',
              title: 'フィンガーポテトの\nフライドスナック',
              text: 'そのまま揚げて簡単スナック！',
              comment: 'そのままでも、ケチャップと一緒でも美味しく召し上がれます。',
              ingredients: [
                {
                  ingredient: 'フィンガーポテト',
                  quantity: 'お好みの量'
                }, {
                  ingredient: 'お好みのソース',
                  quantity: '適量'
                }
              ],
              directions: [
                { direction: '凍ったままのフィンガーポテトを180℃の油で約2分間揚げます。' },
                { direction: 'ケチャップなど、お好みのソースに絡めればできあがり。' }
              ]
            },
            {
              id: 'schupfnudeln2',
              title: 'フィンガーポテトの\n野菜炒め',
              text: 'モチモチポテトが野菜にもよく合う！',
              comment: 'お好きな野菜でお試しください。',
              ingredients: [
                {
                  ingredient: 'フィンガーポテト',
                  quantity: 'お好みの量'
                }, {
                  ingredient: 'ベーコン',
                  quantity: 'お好みの量'
                }, {
                  ingredient: 'さやえんどう',
                  quantity: 'お好みの量'
                }, {
                  ingredient: 'マッシュルーム',
                  quantity: 'お好みの量'
                }, {
                  ingredient: 'その他お好みの野菜',
                  quantity: 'お好みの量'
                }, {
                  ingredient: '塩・こしょう',
                  quantity: '適量'
                }, {
                  ingredient: '醤油',
                  quantity: '適量'
                }
              ],
              directions: [
                { direction: 'フライパンに油を引き、凍ったままのフィンガーポテトを入れ、3〜4分炒めます。' },
                { direction: '火が通ったところで、あらかじめカットしたベーコン、さやえんどう、マッシュルームなどの野菜を入れ、一緒に炒めます。' },
                { direction: '塩・こしょう、醤油で味付けをし、お皿に移せばできあがり。' }
              ]
            },
            {
              id: 'schupfnudeln3',
              title: 'フィンガーポテトで\nジャーマンポテト',
              text: 'ドイツのキャベツのお漬け物、ザワークラウトと合わせて',
              comment: 'よく炒め合わせることで、ザワークラウトの酸味が飛んでマイルドな味わいに',
              ingredients: [
                {
                  ingredient: 'フィンガーポテト',
                  quantity: 'お好みの量'
                }, {
                  ingredient: 'ザワークラフト',
                  quantity: '適量'
                }, {
                  ingredient: 'ベーコン',
                  quantity: '適量'
                }, {
                  ingredient: '三つ葉',
                  quantity: '適量'
                }
              ],
              directions: [
                { direction: 'フィンガーポテトを入れ、焼き色が付くまで3〜4分炒めます。' },
                { direction: 'ベーコン、ザワークラウトを入れよく炒めます。' },
                { direction: '三つ葉を添えてできあがり' }
              ]
            },
            {
              id: 'schupfnudeln4',
              title: 'フィンガーポテトの\nバーニャカウダソース',
              text: '野菜といっしょにフィンガーポテトも蒸しちゃいましょう！バーニャカウダソースがよく合います。',
              comment: 'ボリュームアップでおもてなしにも使えます。',
              ingredients: [
                {
                  ingredient: 'フィンガーポテト',
                  quantity: 'お好みの量'
                }, {
                  ingredient: '好みの野菜',
                  quantity: '適量'
                }, {
                  ingredient: '【バーニャカウダソース】',
                  quantity: '　'
                }, {
                  ingredient: 'アンチョビ',
                  quantity: '2枚'
                }, {
                  ingredient: 'オリーブオイル',
                  quantity: '20ml'
                }, {
                  ingredient: '生クリーム',
                  quantity: '100cc'
                }, {
                  ingredient: '牛乳',
                  quantity: '適量'
                }, {
                  ingredient: '塩・こしょう',
                  quantity: '適量'
                }
              ],
              directions: [
                { direction: 'にんにくは、芯をとっておき、アンチョビはみじん切りにします。' },
                { direction: 'にんにくをたっぷりの牛乳で煮て臭みを取ります。' },
                { direction: '牛乳で臭みを取ったニンニクを包丁でたたきます。' },
                { direction: '冷たいオリーブオイルの中に刻んだアンチョビを入れ、中火で臭みのある水分を飛ばします。' },
                { direction: 'たたいたニンニクと、残りのオリーブオイルを入れてかき混ぜながら、ぷつぷつ沸騰させます。' },
                { direction: '生クリームを加えて、塩胡椒で味をととのえてソースの出来上がり。' },
                { direction: 'お好みの野菜とフィンガーポテトを蒸して、ソースを付けていただきます。' }
              ]
            },
            {
              id: 'schupfnudeln5',
              title: 'フィンガーポテトの\nグラタン風',
              text: 'フィンガーポテトのもちもち食感とあつあつとろけるチーズ、合わないわけがございません！',
              comment: 'チーズはたっぷり使うとより美味しいです！',
              ingredients: [
                {
                  ingredient: 'フィンガーポテト',
                  quantity: '200ｇ'
                }, {
                  ingredient: 'ベーコン',
                  quantity: '50g'
                }, {
                  ingredient: 'ザワークラウト',
                  quantity: '100ｇ'
                }, {
                  ingredient: 'ホワイトソース（市販）',
                  quantity: '1/2缶'
                }, {
                  ingredient: 'エメンタールチーズ（なければ溶けるチーズ）',
                  quantity: '適量'
                }, {
                  ingredient: 'オリーブオイル',
                  quantity: '少量'
                }, {
                  ingredient: '塩・こしょう',
                  quantity: '適量'
                }
              ],
              directions: [
                { direction: 'フライパンに油を敷きザワークラウトを入れ、中火で水気を飛ばしながら炒めます。水気が十分に飛んだら強火にし、あまりかきまぜないようにしてザワークラウトに焦げ目をつけます' },
                { direction: 'フライパンを十分に熱したら中火にし、少量のオリーブオイルを入れてフィンガーポテトを3〜4分炒めます。（最初はフライパン全体で転がすように炒めて、あまり動かさないのがコツ）' },
                { direction: '一緒に一口大に切ったベーコンも炒める。塩胡椒で味を調えます。' },
                { direction: '炒めたザワークラウト、フィンガーポテト、ベーコンを耐熱容器にに盛ってホワイトソースをかける。その上にエメンタールチーズを載せます。' },
                { direction: '200℃に熱したオーブンで表面がほんのり焦げ付くまで焼いて出来上がり（目安は15分くらい）' }
              ]
            },
            {
              id: 'schupfnudeln6',
              title: 'フィンガーポテトの\nザワークラフト和え',
              text: '炒めて酸味がまろやかになったザワークラウトとホワイトソースが合います！',
              comment: 'ホースラディッシュの「ぴりり」が隠し味です',
              ingredients: [
                {
                  ingredient: 'フィンガーポテト',
                  quantity: '200ｇ'
                },
                {
                  ingredient: '市販のザワークラウト',
                  quantity: '100ｇ'
                },
                {
                  ingredient: '市販のホワイトソース',
                  quantity: '1/2缶'
                },
                {
                  ingredient: 'ローストオニオン',
                  quantity: '大さじ1'
                },
                {
                  ingredient: 'ベーコンビッツ',
                  quantity: '大さじ1'
                },
                {
                  ingredient: 'きざみパセリ',
                  quantity: '適量'
                },
                {
                  ingredient: 'サラダ油',
                  quantity: '適量'
                },
                {
                  ingredient: 'ホースラディッシュ',
                  quantity: '適量'
                }
              ],
              directions: [
                { direction: 'フライパンに油を敷きザワークラウトを入れ、中火で水気を飛ばしながら炒めます。水気が十分に飛んだら強火にし、あまりかきまぜないようにしてザワークラウトに焦げ目をつけます。' },
                { direction: 'フライパンを十分に熱したら中火にし、少量のサラダ油を入れてフィンガーポテトを3〜4分炒めます。最初はフライパン全体で転がすように炒めて、あまり動かさないのがコツ。' },
                { direction: '炒めたザワークラウトをお皿に盛りつけ、ホワイトソースをかけます。' },
                { direction: '炒めたフィンガーポテトをザワークラウトに立て掛けるように盛りつけます。' },
                { direction: 'ローストオニオン、ベーコンビッツ、きざみパセリを振りかけ、最後にホースラディッシュをおろしかけて出来上がり。' }
              ]
            },
            {
              id: 'schupfnudeln7',
              title: 'フィンガーポテトの\nかぼちゃクリーム和え',
              text: 'もちもちっぷりとカボチャクリームソースは相性抜群！',
              comment: 'カボチャのつぶし具合はお好みで。なめらかだとクリーミーな仕上がり、多少つぶが残っている食感も楽しいですよ。',
              ingredients: [
                {
                  ingredient: 'フィンガーポテト',
                  quantity: 'お好きな量'
                },
                {
                  ingredient: 'かぼちゃ',
                  quantity: '1/4個'
                },
                {
                  ingredient: '牛乳',
                  quantity: '100cc'
                },
                {
                  ingredient: '生クリーム',
                  quantity: '50cc'
                },
                {
                  ingredient: 'バター',
                  quantity: '適量'
                },
                {
                  ingredient: '塩・こしょう',
                  quantity: '適量'
                }
              ],
              directions: [
                { direction: '角切りにしたかぼちゃを牛乳で煮ます。煮立ったら弱火に、かぼちゃが柔らかくなったら潰しながら牛乳の水分を飛ばしていきます。' },
                { direction: '牛乳の水分がなくなってきたところで、生クリームを少し加えてよく混ぜます。' },
                { direction: '塩胡椒、バターで味を整えて、カボチャクリームのできあがり。' },
                { direction: '3〜4分茹でたフィンガーポテトを絡めていただきます。' }
              ]
            },
            {
              id: 'schupfnudeln8',
              title: 'フィンガーポテトの\nアイスデザート',
              text: '無塩バターでソテーした熱々フィンガーポテトに冷たいアイスを添えて！',
              comment: 'あつあつポテトとつめたーいアイスの組み合わせがポイントです。',
              ingredients: [
                {
                  ingredient: 'フィンガーポテト',
                  quantity: 'お好みの量'
                }, {
                  ingredient: 'お好みのアイス',
                  quantity: 'お好みの量'
                }, {
                  ingredient: '無塩バター',
                  quantity: '適量'
                }, {
                  ingredient: 'お好みのフルーツソース',
                  quantity: '適量'
                }, {
                  ingredient: '季節のフルーツ',
                  quantity: '適量'
                }, {
                  ingredient: 'シュガーパウダー（砂糖）',
                  quantity: '適量'
                }
              ],
              directions: [
                { direction: 'フライパンにバターを引き、凍ったままのフィンガーポテトを入れ、ポテトがキツネ色になるまで炒めます。（3〜4分）' },
                { direction: 'あつあつのうちにお皿に盛って、お好みアイスや季節のフルーツを盛り合わせて、フルーツソースを添えます。仕上げにシュガーパウダーを振り掛ければできあがり。' }
              ]
            },
            {
              id: 'schupfnudeln9',
              title: 'フィンガーポテトの\nチョコドーナツ',
              text: 'チョコとからめてもちもち簡単ドーナツ！',
              comment: 'じっくり揚げることで水分が飛んで、もちもち感がアップ。揚げ油にショートニングを使うと、さらにさくさくになります。',
              ingredients: [
                {
                  ingredient: 'フィンガーポテト',
                  quantity: '200ｇ'
                }, {
                  ingredient: 'ミルクチョコレート',
                  quantity: '100ｇ'
                }, {
                  ingredient: 'パウダーシュガー',
                  quantity: '適量'
                }
              ],
              directions: [
                { direction: '湯せんでチョコレートを溶かしておきます。' },
                { direction: 'フィンガーポテトを170℃の油できつね色になるまで揚げます。（2〜3分）そのまま粗熱をとります。' },
                { direction: '溶かしておいたチョコレートに2.を絡め、パウダーシュガーをふりかけてできあがり。' }
              ]
            }
          ]
        }, {
          key: 'spaetzle',
          de: 'Eierspätzle',
          name: 'シュペッツレ',
          catchphrase: '欧州で愛されている\n卵入りショートパスタ',
          modal: [
            {
              id: 'spaetzle1',
              title: 'シュペッツレ\nお好みのソースで',
              text: 'レンジで簡単！ソースとチーズだけ！',
              comment: '色付けにお好みの野菜を添えても',
              ingredients: [
                {
                  ingredient: 'シュペッツレ',
                  quantity: 'お好みの量'
                },
                {
                  ingredient: 'お好みのソース',
                  quantity: 'お好みの量'
                },
                {
                  ingredient: 'チーズ',
                  quantity: 'お好みの量'
                }
              ],
              directions: [
                { direction: 'シュペッツレを冷凍のままお皿に載せ、お好みのソースとチーズを載せ、電子レンジで温める。' },
                { direction: 'チーズが溶ければ出来上がり（目安は約3分）。' }
              ]
            },
            {
              id: 'spaetzle2',
              title: 'シュペッツレの\nチキンクリームソース',
              text: 'マスタードが隠し味、チキンクリームソースがシュペッツレに良く合います。',
              comment: 'エシャロットの代わりに玉ねぎでもOK！',
              ingredients: [
                {
                  ingredient: 'シュペッツレ',
                  quantity: '200g'
                },
                {
                  ingredient: 'エシャロット',
                  quantity: '　4個'
                },
                {
                  ingredient: '鶏胸肉　',
                  quantity: '100g'
                },
                {
                  ingredient: '生クリーム',
                  quantity: '　80cc'
                },
                {
                  ingredient: 'マスタード',
                  quantity: '　大さじ1'
                },
                {
                  ingredient: 'バター',
                  quantity: '　大さじ1'
                },
                {
                  ingredient: '塩胡椒',
                  quantity: '適量'
                }
              ],
              directions: [
                { direction: 'シュペッツレをボイルする。' },
                { direction: 'エシャロットをみじん切りにしてバターで炒める。' },
                { direction: '一口大にカットした鶏胸肉をいれて、火が通るまで炒める' },
                { direction: '塩、胡椒、生クリーム、マスタードを加えて混ぜ合わせる。' },
                { direction: 'ボイルしたシュペッツレにかけて出来上がり' }
              ]
            },
            {
              id: 'spaetzle3',
              title: 'シュペッツレの\nホワイトソース和え',
              text: '市販のホワイトソースでぱぱっと満足メニュー',
              comment: 'きりっと冷えた白ワインにぴったりです。',
              ingredients: [
                {
                  ingredient: 'シュペッツレ',
                  quantity: '200g'
                }, {
                  ingredient: 'ホワイトソース（市販）',
                  quantity: '200g'
                }, {
                  ingredient: 'ミックスビーンズ',
                  quantity: '1/2缶'
                }, {
                  ingredient: 'パセリ',
                  quantity: '適量'
                }, {
                  ingredient: 'パルメザンチーズ',
                  quantity: '適量'
                }, {
                  ingredient: '塩',
                  quantity: '適量'
                }, {
                  ingredient: 'ブラックペッパー',
                  quantity: '適量'
                }
              ],
              directions: [
                { direction: '鍋でホワイトソースをあたため、そこにシュペッツレとミックスビーンズを入れて混ぜ合わせながら加熱します。' },
                { direction: '塩で味を整えてお皿に盛ります。ブラックペッパーをごりごり挽いて、パセリのみじん切りとたっぷりのパルメザンチーズを振りかければできあがり。' }
              ]
            },
            {
              id: 'spaetzle4',
              title: 'ケーゼ・シュペッツレ',
              text: '南ドイツの家庭の定番メニュー',
              comment: 'みじん切りしておいた玉ねぎとズッキーニをあせらずじっくりゆっくり炒め合わせること。水分がとんで野菜の甘みとコクが引き出されて、ワンランク上の味わいに',
              ingredients: [
                {
                  ingredient: 'シュペッツレ',
                  quantity: '200g'
                }, {
                  ingredient: '玉ねぎ ',
                  quantity: '1/2個'
                }, {
                  ingredient: 'ズッキー二 ',
                  quantity: '1/4個'
                }, {
                  ingredient: 'バター ',
                  quantity: '大さじ1'
                }, {
                  ingredient: '牛乳 ',
                  quantity: '50ml'
                }, {
                  ingredient: '市販のホワイトソース ',
                  quantity: '1缶'
                }, {
                  ingredient: 'エメンタールチーズ ',
                  quantity: '50g'
                }, {
                  ingredient: 'ローストオニオン ',
                  quantity: '適量'
                }, {
                  ingredient: '溶けるチーズ ',
                  quantity: '適量'
                }, {
                  ingredient: '塩・こしょう ',
                  quantity: '適量'
                }, {
                  ingredient: 'マジョラム（あれば） ',
                  quantity: '適量'
                }
              ],
              directions: [
                { direction: 'フライパンにバターを入れ溶かし、みじん切りしておいた玉ねぎとズッキーニをゆっくりとキツネ色になるまで炒め合わせます。' },
                { direction: 'ボウルにシュペッツレを入れたら、牛乳を少し入れ、全体を混ぜ合わせます。' },
                { direction: '２に１を加え、刻んだエメンタールチーズ、ホワイトソース、ローストオニオン、マジョラムを入れ、よく混ぜ合わせます。' },
                { direction: '塩・胡椒で味を整えたら耐熱容器にシュペッツレを入れ、上からローストオニオンと溶けるチーズを振りかけます。' },
                { direction: '170℃に予熱したオーブンで12～15分間くらい焼き上げます。' },
                { direction: '仕上げに、刻みパセリを振りかけたら、出来上がり。' }
              ]
            },
            {
              id: 'spaetzle5',
              title: 'シュペッツレ\nバジル＆ブルーチーズ和え',
              text: 'シュペッツレを香り豊かなバジルソースでいただきます。',
              comment: '濃いめの白ワイン、軽めの赤ワインあたりによく合います。',
              ingredients: [
                {
                  ingredient: 'シュペッツレ',
                  quantity: 'お好きな量'
                }, {
                  ingredient: 'オリーブオイル',
                  quantity: '小さじ１'
                }, {
                  ingredient: '青カビ',
                  quantity: 'チーズ'
                }, {
                  ingredient: '塩・こしょう',
                  quantity: '適量'
                }, {
                  ingredient: 'ミニトマト',
                  quantity: '２〜３個'
                }, {
                  ingredient: 'イタリアンパセリ',
                  quantity: '飾り用'
                }, {
                  ingredient: '【バジルソース】',
                  quantity: '　'
                },
                {
                  ingredient: 'バジルの葉',
                  quantity: '50gくらい'
                }, {
                  ingredient: 'にんにく',
                  quantity: '2片'
                }, {
                  ingredient: '松の実',
                  quantity: '15g'
                }, {
                  ingredient: 'カシューナッツ',
                  quantity: '15g'
                }, {
                  ingredient: '白ごま',
                  quantity: '大さじ1'
                }, {
                  ingredient: 'パルメザンチーズ',
                  quantity: '1/2カップ'
                }, {
                  ingredient: 'エクストラバージンオリーブオイル',
                  quantity: '4/3カップ'
                }, {
                  ingredient: '塩・こしょう',
                  quantity: '適量'
                }
              ],
              directions: [
                { direction: '松の実、カシューナッツ、白ごまはフライパンで軽く煎っておきます。（数種類のナッツを組み合わせることで、味が複雑になります）' },
                { direction: 'すり鉢にナッツ類を入れてよく擂り合わせたら、他の材料をいれてさらに擂り合わせます。' },
                { direction: '塩・こしょうで味をととのえます。（塩はすこし強めに） ' },
                { direction: 'バジルとガーリックの香りがいい、バジルソースのできあがりです。' },
                { direction: 'シュペッツレは沸騰したお湯で２分くらいボイルします。' },
                { direction: '熱したフライパンにオリーズオイル、シュペッツレを入れて、バジルソースとよく絡めます。' },
                { direction: '火を止めて刻んだパジルの葉も混ぜ、塩胡椒で味を整えます。（あまり火を入れるとバジルの緑の色が損なわれるので注意）' },
                { direction: '器に盛り青カビチーズをちらしてミニトマト、イタリアンパセリを飾ればできあがり。' },
                { direction: 'バジルの葉は洗って、ペーパータオルで水気を丁寧にふき取ります。' }
              ]
            },
            {
              id: 'spaetzle6',
              title: 'シュペッツレ\nアーリオオーリオ風ソテー',
              text: 'ガーリックをきかせてアーリオオーリオ風ソテーに。',
              comment: 'ちょっとぴりりと辛いにんにく香るオイルソースです。野菜も一緒炒め合わせて、ヘルシーにいただきましょう！',
              ingredients: [
                {
                  ingredient: 'シュペッツレ',
                  quantity: '200g'
                }, {
                  ingredient: 'にんにく',
                  quantity: '1片'
                }, {
                  ingredient: '赤唐辛子小',
                  quantity: '1本'
                }, {
                  ingredient: 'オリーブオイル',
                  quantity: '大さじ4'
                }, {
                  ingredient: 'アンチョビ（お好みで）',
                  quantity: '2枚'
                }, {
                  ingredient: 'マッシュルーム',
                  quantity: '4個'
                }, {
                  ingredient: '人参',
                  quantity: '1/2本'
                }, {
                  ingredient: 'ブロッコリー',
                  quantity: '3〜4房'
                }, {
                  ingredient: 'イタリアンパセリ',
                  quantity: '適量'
                }, {
                  ingredient: 'チャイブ（飾り用）',
                  quantity: '適量'
                }, {
                  ingredient: '塩・こしょう',
                  quantity: '適量'
                }
              ],
              directions: [
                { direction: '赤唐辛子はちぎって種を取り、にんにくとイタリアンパセリははみじん切り、人参は短冊切り、マッシュルームは薄切りにし、ブロッコリーは一口大に総分けしておきます。' },
                { direction: 'フライパンにオリーブオイルを入れて広げ、赤唐辛子とにんにくを入れて弱火にかけます。にんにくのいい香りがして来たら、中火にして人参、ブロッコリー、マッシュルームの順番で炒め合わせます。（唐辛子とにんにくを焦がさないように）' },
                { direction: '強火にして冷凍のままのシュペッツレを2.に入れて一気に炒め合わせます。' },
                { direction: '塩・こしょうで味を調えて皿に盛ります。' },
                { direction: 'イタリアンパセリを散らして、チャイブ飾りに添えます。' }
              ]
            },
            {
              id: 'spaetzle7',
              title: 'シュペッツレ\nアメリケーヌソース和え',
              text: '海老からとれる旨味たっぷり、コクのある贅沢ソースです。',
              comment: 'お好みで飾りのパプリカやマッシュルームも合わせてどうぞ！',
              ingredients: [
                {
                  ingredient: 'シュペッツレ',
                  quantity: '200g'
                }, {
                  ingredient: '殻つき有頭えび',
                  quantity: '10尾'
                }, {
                  ingredient: 'オリーブオイル',
                  quantity: '小さじ2'
                }, {
                  ingredient: '白ワイン',
                  quantity: '120cc'
                }, {
                  ingredient: 'バター',
                  quantity: '20ｇ'
                }, {
                  ingredient: 'ブーケガルニ',
                  quantity: '適量'
                }, {
                  ingredient: '市販のトマトソース',
                  quantity: '1缶'
                }, {
                  ingredient: 'にんにく',
                  quantity: '１かけ'
                }, {
                  ingredient: '塩・こしょう',
                  quantity: '適量'
                }, {
                  ingredient: '生クリーム',
                  quantity: '50cc'
                }
              ],
              directions: [
                { direction: '海老は、背ワタをとって殻と頭をとる。殻と頭は捨てずにとっておきます。' },
                { direction: '鍋にオリーブオイルとみじん切りにしたにんにくを入れ火にかけて、香りが出てきたら１の殻と頭を入れて軽く炒めます。' },
                { direction: '２に白ワインを入れて軽く煮詰め、トマトソースとブーケガルニを入れて中火で煮ます。' },
                { direction: 'アクを丁寧にとりながら３を中火で煮詰めていく。とろみがついてお好みの濃度になったらざるなどでこします。' },
                { direction: '仕上げにバターを入れて、塩胡椒で味を整えます。' },
                { direction: '火を止めて生クリームを入れてよく混ぜ合わせればソースのできあがり。' },
                { direction: 'シュペッツレは冷凍のまま沸騰したお湯で2～3分ボイルします。' },
                { direction: 'よくお湯をきって、刻んだイタリアンパセリと少量のオリーブオイルで和えます。' },
                { direction: '温めておいた皿にアメリケーヌソースをしいて、シュペッツレを盛り付けます。' }
              ]
            }
          ]
        }
      ]
    }
  },
  methods: {
    modalOpen (n) {
      this.showContent = true
      this.postItem = n
      document.body.classList.add('modal-open')
    },
    modalClose () {
      this.showContent = false
      this.postItem = null
      document.body.classList.remove('modal-open')
    }
  }
}
</script>

<style scoped lang="stylus">
// breakpoint
screen-xs = 600px
screen-sm = 960px
breakpoint(bpName)
    for name in bpName
        if name == 'sm-up'
            @media only screen and (min-width: screen-xs)
                {block}
        if name == 'xs'
            @media only screen and (max-width: screen-xs)
                {block}
        if name == 'sm'
            @media only screen and (max-width: screen-sm)
                {block}
// color
$color-primary = #502e28
$color-secondary = #ecddbc

// font
@import url('https://fonts.googleapis.com/css?family=Satisfy&display=swap');
body.modal-open
  overflow hidden
.item_wrap
  .title_wrap
    position relative
    h2
      background $color-primary
    img
      width 18%
      position absolute
      top -2rem
  h3
    white-space pre-wrap
  .de
    font-family: 'Satisfy', cursive
  .v-card
    cursor pointer
    border-radius 8px
    width 30%
    +breakpoint(sm)
      width 45%
    +breakpoint(xs)
      width 90%
  .v-card__title
    border-bottom-left-radius 8px
    border-bottom-right-radius 8px
    white-space pre-wrap
  .image_btn_text
    font-size .8rem

</style>



// WEBPACK FOOTER //
// src/app/pages/Landing/Recipe/index.vue